import { render, staticRenderFns } from "./BudgetCostGroupDetail.vue?vue&type=template&id=c61ef4aa&scoped=true&"
import script from "./BudgetCostGroupDetail.vue?vue&type=script&lang=js&"
export * from "./BudgetCostGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61ef4aa",
  null
  
)

export default component.exports